export default {
  'verificationcheck.verifycode': 'تحقق من الرمز',
  'verificationcheck.gotoprofile': 'اذهب إلى الملف الشخصي',
  'verificationcheck.entercode': 'أدخل رمز التحقق',
  'verificationcheck.maintext':
    'لمتابعة الرجاء إدخال رمز التحقق هنا ، تم إرسال الرمز إلى ',
  'verificationcheck.continuetext': '.',
  'verificationcheck.evaluate': 'تقييم',
  'verificationcheck.resendcode': 'انقر لإعادة إرسال الرمز',
};
